export const getImage = (imageList, context, ratio, size) =>
  imageList?.[`${context}_${ratio}_${size}`]?.[0]
